import { useStore } from 'framework7-react';
import { FC } from 'react';
import './PaymentReceiptPage.scss';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { store } from '@/config/store';
import { paymentTypeId } from '@/consts/payment';
import { BillInformationDetail } from '@/types/api/customerApi';
import { formatToJaDate, hyphenToYear } from '@/utils/date';

interface PaymentReceiptPageProps {
  billDetail: BillInformationDetail;
}
export const PaymentReceiptPage: FC<PaymentReceiptPageProps> = ({
  billDetail,
}) => {
  const customerInfo = useStore(store, 'customerInfo');

  const formattedBillingDate = hyphenToYear(
    billDetail.billing_date || '',
    false,
  );

  return (
    <PageTemplate
      pageName="PaymentReceiptPage"
      title="領収書"
      showNavBack={true}
    >
      <div className="content-box">
        <div className="header-row">
          {/* 宛名（左上） */}
          <div className="addressee-box">
            <p className="addressee-text">
              {/* eslint-disable-next-line no-magic-numbers */}
              {customerInfo.customer_type === 1
                ? customerInfo.family_name + customerInfo.first_name
                : customerInfo.company_name}
              様
            </p>
          </div>

          {/* 会社情報（右上） */}
          <div className="affiliate-info-box">
            <p className="company-name" style={{ whiteSpace: 'pre-line' }}>
              {billDetail?.m_payment_type_id === paymentTypeId.CREDIT
                ? `${customerInfo.affiliate_name}\n(${customerInfo.affiliate_invoice_service_name_credit})`
                : billDetail?.m_payment_type_id === paymentTypeId.BANK
                ? `${customerInfo.affiliate_name}\n(${customerInfo.affiliate_invoice_service_name_bank})`
                : customerInfo.affiliate_name}
            </p>
            <p>
              {customerInfo.affiliate_invoice_registration_number
                ? `${customerInfo.affiliate_invoice_registration_number}`
                : ''}
            </p>
          </div>
        </div>

        {/* 請求概要 */}
        <div className="amount-box">
          <p className="pay-subject">{billDetail.pay_subject}</p>
          <p>請求日: {formattedBillingDate}</p>

          {/* 金額エリア */}
          <div className="amount-content">
            <div>
              <p className="bill-price-title">
                <strong>お支払額</strong>{' '}
              </p>
              <div className="bill-price-tax-kbn">
                <p>
                  <span
                    className="pay-subject-tax-kbn"
                    style={{ color: '#666666' }}
                  >
                    {billDetail?.prepaid_flg && billDetail?.m_prepaid_id
                      ? '（消費税対象外）'
                      : '（消費税10%込）'}
                  </span>
                </p>
              </div>

              <p className="bill-price">
                {billDetail.bill_price?.toLocaleString()} 円
              </p>
              <div className="bill-price-detail">
                {/* eslint-disable-next-line no-magic-numbers */}
                {!(
                  billDetail?.prepaid_flg === 1 && billDetail?.m_prepaid_id
                ) && (
                  <>
                    <p className="bill-price-tax-exclusive">
                      10％対象{' '}
                      {billDetail.bill_price_tax_exclusive?.toLocaleString()} 円
                    </p>
                    <p className="bill-price-tax">
                      消費税 {billDetail.bill_price_tax?.toLocaleString()} 円
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          <p className="publication-date">
            発行日付：{formatToJaDate(new Date())}
          </p>
        </div>
      </div>
    </PageTemplate>
  );
};
